import type { SuggestedAddress } from '../../../core/models/address-validate';

/**
 * Formats a suggested address as a single display line for the correction panel.
 */
export function formatSuggestedAddressLine(suggestedAddress: SuggestedAddress): string {
  const streetParts: string[] = [];
  const line1 = suggestedAddress.addressLine1.trim();
  const line2 = suggestedAddress.addressLine2.trim();

  if (line1.length > 0) {
    streetParts.push(line1);
  }

  if (line2.length > 0) {
    streetParts.push(line2);
  }

  const localityParts: string[] = [];
  const city = suggestedAddress.municipalityName.trim();
  const province = suggestedAddress.provinceCode.trim();
  const postalCode = suggestedAddress.postalCode.trim();

  if (city.length > 0) {
    localityParts.push(city);
  }

  const provincePostal = [province, postalCode].filter((part) => part.length > 0).join(' ');
  if (provincePostal.length > 0) {
    localityParts.push(provincePostal);
  }

  return [...streetParts, localityParts.join(', ')].filter((part) => part.length > 0).join(', ');
}
